import useAuthState, { Tenant } from '@/states/auth.state';
import useTenantState from '@/states/tenant.state';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { useQueryClient } from '@tanstack/react-query';
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@/components/ui/Avatar';
import useOrganizationListState from '@/states/organization-list.state';
import useCompanyProfileCompletionState from '@/states/completion.state';

export default function TenantList({ className }: { className?: string }) {
  const { tenants } = useAuthState();
  const { currentTenant } = useTenantState();
  return (
    <div className={className}>
      <Menu>
        <MenuButton>
          <div className="flex items-center justify-center select-none cursor-pointer gap-2 ">
            <Avatar name={currentTenant?.name ?? ''} imagePath={currentTenant?.logoPath} className="cursor-pointer" />
            <span className="font-medium text-sm truncate max-w-[130px]">{currentTenant?.name}</span>
            <ChevronDown size={14} />
          </div>
        </MenuButton>

        <TenantMenu tenants={tenants} />
      </Menu>
    </div>
  );
}

function TenantMenu(props: { tenants?: Tenant[] }) {
  const { tenants } = props;
  const navigate = useNavigate();
  const { setCurrentTenant, currentTenant } = useTenantState();
  const queryClient = useQueryClient();
  const { fetchOrganizations } = useOrganizationListState();
  const { fetchCompletion } = useCompanyProfileCompletionState();

  return (
    <MenuItems
      // @ts-expect-error entah mengapa error. tetapi jalan well
      transition
      className="flex flex-col origin-top-right p-2 !max-h-80 overflow-auto border bg-white shadow-lg z-[51] rounded-lg transition duration-100 ease-out data-closed:scale-95 data-closed:opacity-0 scrollbar-none"
      anchor="bottom start"
    >
      {tenants?.map(tenant => {
        return (
          <MenuItem key={tenant.id}>
            <button
              className={classNames('w-full p-3 text-left text-sm rounded cursor-pointer hover:bg-gray-100', {
                'bg-blue-100 text-primary hover:bg-blue-200': currentTenant?.slug === tenant.slug,
              })}
              onClick={async () => {
                setCurrentTenant(tenant);
                queryClient.clear();

                navigate(`/${tenant.slug}`);
              }}
            >
              <div className="flex items-center gap-2">
                <Avatar name={tenant.name} imagePath={tenant.logoPath} />
                <span className="text-sm md:text-base">{tenant.name}</span>
              </div>
            </button>
          </MenuItem>
        );
      })}
    </MenuItems>
  );
}
